import React from "react";
import Popup from "../../common/Popup/Popup";
import CategoryTable from "./CategoryTable";

const CategoryPopup = ({ onClose, handleSelectCategory, disableFilter,cat_type,addRow=false,useTableInAuditTrail=false,auditTrailRow }) => {
  return (
    <>
      <Popup title={"Category Table"} closeModal={onClose}>
        <CategoryTable
          handleSelectCategory={handleSelectCategory}
          disableFilter={disableFilter}
          cat_type={cat_type}
          addRow={addRow}
          useTableInAuditTrail={useTableInAuditTrail} auditTrailRow={auditTrailRow}
        />
      </Popup>
    </>
  );
};

export default CategoryPopup;
